import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'cardExpiration',
  standalone: true
})
export class CardExpirationPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) protected locale: string
  ) {}
  transform(
    value: string|undefined,
    options = {
      fromFormat: /^(?<month>.*)\/(?<year>.*)$/,
      toFormat: 'MM/yy'}
  ): any  {
    if (!value) {
      return '';
    }

    const { fromFormat, toFormat } = options;

    const fromPattern = typeof fromFormat === 'string' ? new RegExp(fromFormat) : fromFormat;
    const match = fromPattern.exec(value);
    const { month, year } = match?.groups ?? { month: null, year: null };
    // Value didn't match the expected pattern (e.g. "MMYY" without a separator) —
    // return it unchanged rather than throwing on a null match.
    if (!month || !year) {
      return value;
    }
    const monthInt = parseInt(month, 10) - 1; // js month start from zero
    let yearInt = parseInt(year, 10);
    // Two-digit years must map to 20xx — `new Date(30, …)` is 1930 in JS.
    if (String(year).replace(/\D/g, '').length <= 2) {
      yearInt = 2000 + (yearInt % 100);
    }
    const expDate = new Date(yearInt, monthInt, 5, 0, 0, 0, 0);
    const datePipe = new DatePipe(this.locale);
    return datePipe.transform(expDate, toFormat);
  }
}
